import { API_URL } from '../../../app-config/constants';
import type NotificationCountDto from '../../../types/NotificationCountDto';
import { get, post } from '../request';

const BASE = `${API_URL}/notificationLogs/count`;

getCount.operation = 'READ';
export function getCount() {
    return get<NotificationCountDto>(`${BASE}/new`);
}

resetCount.operation = 'UPDATE';
export function resetCount(countObj: object) {
    return post<NotificationCountDto>(`${BASE}/reset`, { postData: countObj });
}
